import { EditReqBskComponent } from './edit-reqbsk/edit-reqbsk.component';
import { AddReqBskComponent } from './add-reqbsk/add-reqbsk.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListReqBskComponent } from './list-reqbsk/list-reqbsk.component';

export const routesReqBsk: Routes = [
    { path: 'page-reqbsk', component: ListReqBskComponent},
    { path: 'page-reqbsk/add', component: AddReqBskComponent},
    { path: 'page-reqbsk/:id/edit', component: EditReqBskComponent}
];

export const ReqBskRoutes: ModuleWithProviders = RouterModule.forChild(routesReqBsk);
